export default __webpack_public_path__ + "static/media/knee-pads.1da11752.svg";